/* eslint-disable @typescript-eslint/no-explicit-any */
import Vue from 'vue';

export function Setup() {
  Vue.directive('visible', function(el: HTMLElement, binding: any) {
    el.style.visibility = binding.value ? 'visible' : 'hidden';
  });
}